import { IoEllipsisVertical } from "react-icons/io5";

type buttonProps = {
  text: string;
  onClick?: (e?: any) => void;
  loading?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
  color?: string;
  disabled?: boolean;
  iconFirst?: boolean;
  icon?: any;
  fullWidth?: boolean;
};

export default function PrimaryBtn({
  text,
  color,
  onClick,
  loading,
  type,
  disabled,
  fullWidth,
}: buttonProps) {
  const hover = !color ? "enabled:hover:bg-brand-700" : "hover:opacity-90";

  return (
    <button
      onClick={onClick}
      type={type ? type : "button"}
      disabled={disabled}
      className={`${color ? color : "bg-customGreen-primary border border-customGreen-primary"} active:border-brand-100
       text-white font-medium rounded-lg px-3 py-2
         disabled:bg-brand-200 disabled:border-brand-200 text-base ${hover} ${
           fullWidth && "w-full"
         } flex items-center justify-center min-w-[72px]`}
    >
      {loading ? <Loader /> : text}
    </button>
  );
}

export function ActionButton({ onClick }) {
  return (
    <button className="ml-2 px-4 py-2 text-gray-600" onClick={onClick}>
      <IoEllipsisVertical />
    </button>
  );
}

export function IconButton({
  icon,
  text,
  color,
  onClick,
  loading,
  iconFirst = true,
  type = "button",
}: buttonProps) {
  const hover = !color ? "enabled:hover:bg-brand-700" : "opacity-90";

  return (
    <button
      onClick={onClick}
      type={type}
      disabled={loading}
      className={`${hover} ${color ? color : "bg-customGreen-primary border border-customGreen-primary"} text-white font-medium 
      rounded-lg px-3 py-2 flex gap-2 items-center text-base active:border-brand-100`}
    >
      {loading ? (
        <Loader />
      ) : (
        <>
          {iconFirst ? (
            <>
              {icon} {text}
            </>
          ) : (
            <>
              {text} {icon}
            </>
          )}
        </>
      )}
    </button>
  );
}

export function SecondaryIconButton({
  icon,
  text,
  color,
  onClick,
  loading,
}: buttonProps) {
  return (
    <button
      onClick={onClick}
      type="button"
      disabled={loading}
      className={`${color ? color : "bg-transparent border-customGreen-primary"} text-customGreen-primary font-medium rounded-lg px-3 py-2 flex gap-2 items-center 
        hover:opacity-90 border  text-sm`}
    >
      {loading ? (
        <Loader />
      ) : (
        <>
          {icon} {text}
        </>
      )}
    </button>
  );
}

export const SecondaryBtn = ({
  text,
  onClick,
  disabled,
  fullWidth,
  type,
  loading,
}: buttonProps) => {
  return (
    <button
      type={type ? type : "button"}
      disabled={disabled}
      onClick={onClick}
      className={`bg-transparent text-black-secondary font-medium border border-gray-300  rounded-lg px-3 py-2 flex justify-center
        enabled:hover:bg-gray-50 disabled:border-gray-200 disabled:text-gray-300 text-base active:drop-shadow-lg ${
          fullWidth && "w-full"
        }`}
    >
      {loading ? <Loader /> : text}
    </button>
  );
};

export const Loader = () => {
  return (
    <svg
      aria-hidden="true"
      role="status"
      className="w-5 h-5 text-white animate-spin"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="#E5E7EB"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentColor"
      />
    </svg>
  );
};
